(function(root, factory) {
  "use strict";
  var api = factory(root);
  if (root) root.DYOFPreviewRules = api;
  if (typeof module === "object" && module.exports) module.exports = api;
})(typeof globalThis !== "undefined" ? globalThis : this, function(root) {
  "use strict";

  var IDENTITY = [1, 0, 0, 1, 0, 0];
  var NUMBER = /[-+]?(?:\d*\.)?\d+(?:e[-+]?\d+)?/ig;

  function numbers(value) {
    var source = String(value || "");
    var values = source.match(NUMBER) || [];
    if (source.replace(NUMBER, "").replace(/[\s,]/g, "")) throw new Error("Unsupported SVG numbers");
    values = values.map(Number);
    if (!values.every(Number.isFinite)) throw new Error("Invalid SVG number");
    return values;
  }

  function multiply(a, b) {
    return [
      a[0] * b[0] + a[2] * b[1], a[1] * b[0] + a[3] * b[1],
      a[0] * b[2] + a[2] * b[3], a[1] * b[2] + a[3] * b[3],
      a[0] * b[4] + a[2] * b[5] + a[4], a[1] * b[4] + a[3] * b[5] + a[5]
    ];
  }

  function transform(value) {
    var source = String(value || "").trim();
    if (!source || source === "none") return IDENTITY.slice();
    var result = IDENTITY.slice();
    var expression = /([a-zA-Z]+)\s*\(([^)]*)\)/g;
    var match;
    var end = 0;
    while ((match = expression.exec(source))) {
      if (source.slice(end, match.index).replace(/[\s,]/g, "")) throw new Error("Unsupported SVG transform");
      var args = numbers(match[2]);
      var next;
      if (match[1] === "matrix" && args.length === 6) next = args;
      else if (match[1] === "translate" && (args.length === 1 || args.length === 2)) next = [1, 0, 0, 1, args[0], args[1] || 0];
      else if (match[1] === "scale" && (args.length === 1 || args.length === 2)) next = [args[0], 0, 0, args.length === 2 ? args[1] : args[0], 0, 0];
      else if (match[1] === "rotate" && (args.length === 1 || args.length === 3)) {
        var angle = args[0] * Math.PI / 180;
        next = [Math.cos(angle), Math.sin(angle), -Math.sin(angle), Math.cos(angle), 0, 0];
        if (args.length === 3) next = multiply(multiply([1, 0, 0, 1, args[1], args[2]], next), [1, 0, 0, 1, -args[1], -args[2]]);
      } else throw new Error("Unsupported SVG transform");
      result = multiply(result, next);
      end = expression.lastIndex;
    }
    if (!end || source.slice(end).replace(/[\s,]/g, "")) throw new Error("Unsupported SVG transform");
    return result;
  }

  function point(matrix, x, y) {
    return { x: matrix[0] * x + matrix[2] * y + matrix[4], y: matrix[1] * x + matrix[3] * y + matrix[5] };
  }

  function length(value, reference, fallback) {
    if (value === null || value === undefined || value === "") return fallback;
    var match = String(value).trim().match(/^([-+]?(?:\d*\.)?\d+(?:e[-+]?\d+)?)(px|%)?$/i);
    if (!match) throw new Error("Unsupported SVG length");
    var result = Number(match[1]) * (match[2] === "%" ? reference / 100 : 1);
    if (!Number.isFinite(result)) throw new Error("Invalid SVG length");
    return result;
  }

  function viewport(viewBox, width, height, aspect) {
    var box = numbers(viewBox);
    if (box.length !== 4 || box[2] <= 0 || box[3] <= 0 || width <= 0 || height <= 0) throw new Error("Invalid SVG viewport");
    var sx = width / box[2], sy = height / box[3];
    var align = String(aspect || "xMidYMid meet").trim();
    if (align === "none") return [sx, 0, 0, sy, -box[0] * sx, -box[1] * sy];
    var match = align.match(/^(xMin|xMid|xMax)(YMin|YMid|YMax)(?:\s+(meet|slice))?$/);
    if (!match || match[3] === "slice") throw new Error("Unsupported SVG viewport alignment");
    var scale = Math.min(sx, sy);
    var ax = { xMin: 0, xMid: 0.5, xMax: 1 }[match[1]];
    var ay = { YMin: 0, YMid: 0.5, YMax: 1 }[match[2]];
    return [scale, 0, 0, scale, (width - box[2] * scale) * ax - box[0] * scale, (height - box[3] * scale) * ay - box[1] * scale];
  }

  function endpoints(element) {
    if (element.localName === "line") return ["x1", "y1", "x2", "y2"].map(function(name) {
      var value = element.getAttribute(name);
      if (String(value || "").includes("%")) throw new Error("Unsupported rule percentage");
      return length(value, 0, 0);
    });
    if (element.localName !== "path") throw new Error("Unsupported rule shape");
    var match = String(element.getAttribute("d") || "").trim().match(/^M\s+([-+.\de]+)\s+([-+.\de]+)\s+L\s+([-+.\de]+)\s+([-+.\de]+)\s*$/i);
    if (!match) throw new Error("Unsupported rule path");
    return match.slice(1).map(Number);
  }

  function snapRule(rule, density) {
    var output = Object.assign({}, rule);
    // Snap the footprint, not the visual weight. The source's projected width
    // determines ink coverage; a subpixel rule uses one DEVICE pixel with
    // proportional alpha instead of becoming a dark one-CSS-pixel divider.
    var projectedWidth = Number(rule.width);
    var sourceWeighted = !rule.dash && Number.isFinite(projectedWidth) && projectedWidth > 0;
    output.width = rule.dash ? rule.width : sourceWeighted ? Math.max(1, Math.ceil(projectedWidth)) : Math.max(1, Math.round(Math.min(3, Math.max(1, Number(density) || 1))));
    if (sourceWeighted) output.opacity = rule.opacity * projectedWidth / output.width;
    if (Math.abs(rule.y1 - rule.y2) <= 0.0001 && Math.abs(rule.x1 - rule.x2) > 0.0001) {
      output.y1 = output.y2 = Math.round((rule.y1 + rule.y2) / 2 - output.width / 2) + output.width / 2;
      if (rule.dash) {
        output.x1 = Math.round(rule.x1 - output.width / 2) + output.width / 2;
        output.x2 = rule.x2 + output.x1 - rule.x1;
      }
    } else if (Math.abs(rule.x1 - rule.x2) <= 0.0001 && Math.abs(rule.y1 - rule.y2) > 0.0001) {
      output.x1 = output.x2 = Math.round((rule.x1 + rule.x2) / 2 - output.width / 2) + output.width / 2;
      if (rule.dash) {
        output.y1 = Math.round(rule.y1 - output.width / 2) + output.width / 2;
        output.y2 = rule.y2 + output.y1 - rule.y1;
      }
    } else throw new Error("Rule is not axis aligned");
    return output;
  }

  function prepareTree(svg, options) {
    var width = Math.max(1, Math.round(Number(options.width)));
    var height = Math.max(1, Math.round(Number(options.height)));
    if (!Number.isFinite(width) || !Number.isFinite(height) || width > 8192 || height > 8192) throw new Error("Invalid preview dimensions");
    var rules = [], markedCount = 0;
    function visit(element, parent, isRoot) {
      var marked = element.hasAttribute("data-source-stroke-width");
      if (marked) markedCount += 1;
      var current = { matrix: parent.matrix, width: parent.width, height: parent.height, opacity: parent.opacity, supported: parent.supported };
      try {
        if (["style", "clip-path", "mask", "filter"].some(function(name) { return element.hasAttribute(name); })) throw new Error("Unsupported rule effect");
        current.matrix = multiply(current.matrix, transform(element.getAttribute("transform")));
        if (element.hasAttribute("opacity")) {
          var opacity = Number(element.getAttribute("opacity"));
          if (!Number.isFinite(opacity) || opacity < 0 || opacity > 1) throw new Error("Invalid opacity");
          current.opacity *= opacity;
        }
        if (element.localName === "svg") {
          var vw = isRoot ? width : length(element.getAttribute("width"), parent.width, parent.width);
          var vh = isRoot ? height : length(element.getAttribute("height"), parent.height, parent.height);
          var x = isRoot ? 0 : length(element.getAttribute("x"), parent.width, 0);
          var y = isRoot ? 0 : length(element.getAttribute("y"), parent.height, 0);
          current.matrix = multiply(current.matrix, [1, 0, 0, 1, x, y]);
          var viewBox = element.getAttribute("viewBox");
          if (viewBox) {
            current.matrix = multiply(current.matrix, viewport(viewBox, vw, vh, element.getAttribute("preserveAspectRatio")));
            var box = numbers(viewBox);
            current.width = box[2]; current.height = box[3];
          } else { current.width = vw; current.height = vh; }
        } else if (!isRoot && !["g", "line", "path"].includes(element.localName)) current.supported = false;
      } catch (_error) { current.supported = false; }

      if (marked && current.supported) {
        try {
          var sourceWidth = Number(element.getAttribute("data-source-stroke-width"));
          if (!Number.isFinite(sourceWidth) || sourceWidth <= 0 || sourceWidth > 0.6) throw new Error("Unsupported source rule");
          var dashText = element.getAttribute("stroke-dasharray");
          var dash = dashText ? numbers(dashText) : null;
          if (dash && (element.getAttribute("data-source-dash") !== dashText || !dash.length || dash.some(function(value) { return value < 0; }) || !dash.some(function(value) { return value > 0; }))) throw new Error("Unsupported source dash pattern");
          var xy = endpoints(element);
          var first = point(current.matrix, xy[0], xy[1]), last = point(current.matrix, xy[2], xy[3]);
          var colour = String(element.getAttribute("stroke") || "").trim();
          if (!/^(?:#[0-9a-f]{3,8}|(?:rgb|rgba)\([\d\s.,%]+\)|black|white)$/i.test(colour)) throw new Error("Unsupported stroke colour");
          var alpha = element.hasAttribute("stroke-opacity") ? Number(element.getAttribute("stroke-opacity")) : 1;
          if (!Number.isFinite(alpha) || alpha < 0 || alpha > 1) throw new Error("Invalid stroke opacity");
          if (!dash && element.hasAttribute("data-source-stroke-opacity")) {
            alpha = Number(element.getAttribute("data-source-stroke-opacity"));
            if (!Number.isFinite(alpha) || alpha < 0 || alpha > 1) throw new Error("Invalid source opacity");
          } else if (!dash && options.legacySolidOpacityScale === 0.65) {
            // Only the explicitly pinned September/October v1 sidecars lost
            // source alpha. All 4,680 verified solids use the exact .65
            // fallback for original alpha 1; never infer arbitrary values.
            if (alpha !== 0.65) throw new Error("Unsupported legacy rule opacity");
            alpha = 1;
          }
          var cap = element.getAttribute("stroke-linecap") || "butt";
          if (!["butt", "round", "square"].includes(cap)) throw new Error("Unsupported stroke cap");
          var paint = { x1: first.x, y1: first.y, x2: last.x, y2: last.y, colour: colour, opacity: alpha * current.opacity, lineCap: cap };
          var alongScale = Math.hypot(last.x - first.x, last.y - first.y) / Math.hypot(xy[2] - xy[0], xy[3] - xy[1]);
          var acrossScale = Math.abs(current.matrix[0] * current.matrix[3] - current.matrix[1] * current.matrix[2]) / alongScale;
          if (!Number.isFinite(alongScale) || !Number.isFinite(acrossScale) || acrossScale <= 0) throw new Error("Invalid rule transform");
          paint.width = sourceWidth * acrossScale;
          if (dash) {
            var sourceDashOffset = Number(element.getAttribute("stroke-dashoffset") || 0);
            if (!Number.isFinite(alongScale) || !Number.isFinite(acrossScale) || !Number.isFinite(sourceDashOffset)) throw new Error("Invalid dash transform");
            var minimum = options.dottedMinimum === undefined ? 0.4 : Math.min(0.4, Math.max(0, Number(options.dottedMinimum) || 0));
            var density = Math.min(3, Math.max(1, Number(options.density) || 1));
            paint.width = Math.max(sourceWidth * acrossScale, minimum * density);
            paint.dash = dash.map(function(value) { return value * alongScale; });
            paint.dashOffset = sourceDashOffset * alongScale;
            // The minimum makes tiny dots consistently rasterisable, but must
            // not add visual ink. Preserve the original dash/cap area by alpha
            // compensation. Source pattern, spacing and phase stay unchanged.
            if (paint.width > sourceWidth * acrossScale) {
              var sourceProjected = sourceWidth * acrossScale;
              var cycle = paint.dash.length % 2 ? paint.dash.concat(paint.dash) : paint.dash;
              var onLength = cycle.reduce(function(total, value, index) { return total + (index % 2 === 0 ? value : 0); }, 0);
              var onCount = cycle.length / 2;
              var capArea = cap === "round" ? Math.PI / 4 : cap === "square" ? 1 : 0;
              var originalInk = onLength * sourceProjected + onCount * capArea * sourceProjected * sourceProjected;
              var enlargedInk = onLength * paint.width + onCount * capArea * paint.width * paint.width;
              if (enlargedInk > 0) paint.opacity *= originalInk / enlargedInk;
            }
            if (Math.hypot(last.x - first.x, last.y - first.y) / paint.dash.reduce(function(total, value) { return total + value; }, 0) > 10000) throw new Error("Unsupported dash density");
          }
          var rule = snapRule(paint, options.density);
          if (![rule.x1, rule.y1, rule.x2, rule.y2].every(Number.isFinite)) throw new Error("Invalid rule coordinates");
          if (Math.min(rule.x1, rule.x2) < 0 || Math.max(rule.x1, rule.x2) > width || Math.min(rule.y1, rule.y2) < 0 || Math.max(rule.y1, rule.y2) > height) throw new Error("Rule crosses viewport bounds");
          rules.push(rule);
          element.remove();
          return;
        } catch (_error) { }
      }
      Array.from(element.children || []).forEach(function(child) { visit(child, current, false); });
    }
    visit(svg, { matrix: IDENTITY, width: width, height: height, opacity: 1, supported: true }, true);
    svg.setAttribute("width", String(width));
    svg.setAttribute("height", String(height));
    return { rules: rules, skippedCount: markedCount - rules.length, markedCount: markedCount, width: width, height: height };
  }

  function prepareSvg(svgText, options) {
    if (!root.DOMParser || !root.XMLSerializer) throw new Error("SVG parsing is unavailable");
    var document = new root.DOMParser().parseFromString(svgText, "image/svg+xml");
    if (document.querySelector("parsererror") || document.documentElement.localName !== "svg") throw new Error("Invalid preview SVG");
    var prepared = prepareTree(document.documentElement, options || {});
    prepared.svg = new root.XMLSerializer().serializeToString(document);
    return prepared;
  }

  function drawRules(context, rules) {
    context.save();
    try {
      context.setTransform(1, 0, 0, 1, 0, 0);
      context.globalCompositeOperation = "source-over";
      rules.forEach(function(rule) {
        context.strokeStyle = rule.colour;
        context.globalAlpha = rule.opacity;
        context.lineWidth = rule.width;
        context.lineCap = rule.lineCap;
        if (rule.dash && rule.dash.length === 2 && rule.dash[0] === 0 && rule.lineCap === "round") {
          var period = rule.dash[1];
          var extent = Math.hypot(rule.x2 - rule.x1, rule.y2 - rule.y1);
          var dx = (rule.x2 - rule.x1) / extent, dy = (rule.y2 - rule.y1) / extent;
          var offset = ((period - ((rule.dashOffset || 0) % period)) % period + period) % period;
          context.fillStyle = rule.colour;
          context.beginPath();
          for (var distance = offset; distance <= extent + 0.000001; distance += period) {
            var x = rule.x1 + distance * dx, y = rule.y1 + distance * dy;
            context.moveTo(x + rule.width / 2, y);
            context.arc(x, y, rule.width / 2, 0, 2 * Math.PI);
            context.closePath();
          }
          context.fill();
          return;
        }
        context.setLineDash(rule.dash || []);
        context.lineDashOffset = rule.dashOffset || 0;
        context.beginPath(); context.moveTo(rule.x1, rule.y1); context.lineTo(rule.x2, rule.y2); context.stroke();
      });
    } finally { context.restore(); }
  }

  return { prepareSvg: prepareSvg, prepareTree: prepareTree, drawRules: drawRules, snapRule: snapRule, multiply: multiply, transform: transform, viewport: viewport, point: point };
});
